import Vue from "vue";
import ApiService from "@/common/api.service";
import {
  ExpClientsService,
} from "@/common/api.service";
import toast from '@/services/toast'

import {
    SET_ACTIVE_EXPCLIENT,
    FETCH_EXPCLIENT_LIST,
    FETCH_EXPCLIENT,
    CREATE_EXPCLIENT_USER
} from "./actions.type";
import {
    SET_EXPCLIENT_LIST,
    SET_EXPCLIENT_ID,
    SET_EXPCLIENT,
    SET_ERROR
} from "./mutations.type";

const initialState = {
    activeExpClient: null,
    activeExpClientId: null,
    expClientList: [],
    totalClients: 0,
    currentPage: 1,
    hasMorePages: true
};

export const state = {
    ...initialState
};

export const actions = {

    [FETCH_EXPCLIENT](context, params) {
      let clientId = null
      // avoid extronuous network call if collection exists
      if (state.activeExpClient !== null) {

        if (state.activeExpClient.id) {
          console.log('Re-using Client object.');
          return state.activeExpClient
        }
        context.commit(SET_ERROR, 'Active client issue')
        return 'ISSUE'
      }

      if (this.state.auth.user.client_id) {
        console.log('Used Client ID from user profile.');
        clientId = this.state.auth.user.client_id
      }
      else if (params.clientId) {
        console.log('Set client from url');
        clientId = params.clientId
      }
      else {
        console.log('no active');
        return 'NO ACTIVE CLIENT';
      }
      context.commit(SET_EXPCLIENT_ID, clientId);
      ExpClientsService.get(clientId).then((resp)=> {
        console.log(resp, 'Get Client')
        if (resp.data.name) {
          let expClient = resp.data

          context.commit(SET_EXPCLIENT, expClient)
          return resp.data;
        }
        else{
          context.commit(SET_ERROR, 'Something went wrong getting client')
        }
      });
      return state.activeExpClient;
    },
    async [FETCH_EXPCLIENT_LIST](context, { userId, page = 1, search = '', append = false }) {
      const { data } = await ExpClientsService.getList(userId, { page, search });
      context.commit(SET_EXPCLIENT_LIST, {
        clients: data.data,
        total: data.total,
        currentPage: page,
        append
      });
      return data.data;
    },

    [SET_ACTIVE_EXPCLIENT](context, expClient) {
      context.commit(SET_EXPCLIENT, expClient)
    },

    [CREATE_EXPCLIENT_USER](context, credentials) {
      return new Promise((resolve, reject) => {
          ApiService.post("/users",
                  credentials
              )
              .then(({
                  data
              }) => {
                  console.log(data);
                  toast.success(data.message)
                  // context.commit(SET_AUTH, data.user);
                  resolve(data);
              })
              .catch(({
                  response
              }) => {
                  // console.log(response);
                  // context.commit(SET_ERROR, response.data.errors);
                  reject(response);
              });
      });
    },
};

/* eslint no-param-reassign: ["error", { "props": false }] */
export const mutations = {
    [SET_EXPCLIENT](state, expClient) {
        state.activeExpClient = expClient;
    },
    [SET_EXPCLIENT_ID](state, expClientId) {
        state.activeExpClientId = expClientId;
    },
    [SET_EXPCLIENT_LIST](state, { clients, total, currentPage, append }) {
        state.expClientList = append ? [...state.expClientList, ...clients] : clients;
        state.totalClients = total;
        state.currentPage = currentPage;
        state.hasMorePages = state.expClientList.length < total;
    },
};

const getters = {
    activeExpClient(state) {
      return state.activeExpClient;
    },
    activeExpClientId(state) {
      return state.activeExpClientId;
    },
    expClientList(state) {
      return state.expClientList;
    },
    hasMorePages(state) {
        return state.hasMorePages;
    },
    totalClients(state) {
        return state.totalClients;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
